import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import baseStyles from '../../styles/app.scss';
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar/Sidebar';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div className="container-fluid root-container">
        <div className="content">
          <div className="row">
            <div className="col-xs-12">
              <Element name="top" />
              <Header />
              {this.props.children}
              <Sidebar />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(baseStyles)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js